<template>
  <main>
    <div class="container-fluid">

      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="searchControl" data-bs-toggle="pill" data-bs-target="#searchControl"
            type="button" role="tab" aria-controls="searchControl" aria-selected="true"> 查詢 </button>
        </li>

      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <searchParkingLimit></searchParkingLimit>
      </div>
    </div>
  </main>
</template>


<script>
import moment from "moment";
import {mapState, mapGetters} from 'vuex'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import searchParkingLimit from './searchParkingLimit.vue'
    export default{
        components: { searchParkingLimit},
        data(){
            return{

            }
        },
    }
</script>